/**
 * Paper 9EA-0 — Skip funding confirmation (Fund your account later).
 */
export default function MemberSetupSkipDirectDeposit({
  variant = "unlimited",
  instantBonus = 100,
  directDepositBonus = 200,
  spendingQualifier = "$250",
  onGoBack,
  onConfirmSkip,
}) {
  const isBasicPlan = variant === "basic";

  const title = isBasicPlan
    ? "Are you sure you want to skip adding funds for now?"
    : "Are you sure you want to skip direct deposit?";

  const body = isBasicPlan
    ? `You'll need to fund your Stake account to activate Stake Debit. Your $${instantBonus} Cash Back bonus unlocks after you spend ${spendingQualifier} on Stake Debit.`
    : `Without direct deposit, you'll switch to the $${instantBonus} Instant plan. You'll earn $${instantBonus} after your first Stake debit purchase instead of $${directDepositBonus} instantly after a qualifying Direct Deposit.`;

  const confirmLabel = isBasicPlan ? "Yes, skip for now" : "Yes, skip direct deposit";

  return (
    <div className="bc-skip-dd-confirm">
      <div className="bc-skip-dd-icon" aria-hidden>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 6v7" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="12" cy="17.5" r="1.5" fill="#FFFFFF" />
        </svg>
      </div>

      <h2 className="bc-skip-dd-title">{title}</h2>
      <p className="bc-skip-dd-body">{body}</p>

      <div className="bc-skip-dd-actions">
        <button type="button" className="bc-skip-dd-btn bc-skip-dd-btn--secondary" onClick={onGoBack}>
          Go back
        </button>
        <button type="button" className="bc-skip-dd-btn bc-skip-dd-btn--primary" onClick={onConfirmSkip}>
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}
